<template>
  <v-app id="opendata">
    <TopAppBar />
    <v-main>
      <Home />
    </v-main>
  </v-app>
</template>

<script>
import TopAppBar from "@/components/TopAppBar.vue";
import Home from "./views/Home";

export default {
  name: "App",
  title: "OpenData CépiDc",
  components: {
    TopAppBar,
    Home
  },
  data: function() {
    return {};
  },
  methods: {}
};
</script>
<style>
@import "styles/main.css";
</style>
